module.exports = __webpack_public_path__ + "img/216.7fefab60.jpeg";